// extracted by mini-css-extract-plugin
module.exports = {"XColor":"#074e8c"};